export default __webpack_public_path__ + "static/media/Maestro.23c59da3.svg";